import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { rupiah } from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";
import { GATE_STYLE } from "@/lib/constants";
import { Progress } from "@/components/ui/progress";
import { Building2, FolderOpenDot, AlertTriangle, ShieldAlert, Ban } from "lucide-react";

function Stat({ icon: Icon, label, value, tone = "" }) {
  return (
    <div className="bg-white border border-border rounded-sm p-4 flex items-start gap-3" data-testid={`stat-${label}`}>
      <div className={`p-2 rounded-sm ${tone || "bg-muted"}`}><Icon size={18} /></div>
      <div>
        <div className="text-2xl font-head font-bold tabular">{value}</div>
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/dashboard").then((r) => setData(r.data)); }, []);

  if (!data) return <Layout><PageHeader title="Beranda" /><div className="p-6 text-sm text-muted-foreground">Memuat...</div></Layout>;
  const s = data.stats;

  return (
    <Layout>
      <PageHeader title="Beranda" subtitle="Ikhtisar seluruh perikatan audit" breadcrumb="Audit OS" />
      <div className="p-6 space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <Stat icon={Building2} label="Klien" value={s.clients} />
          <Stat icon={FolderOpenDot} label="Perikatan" value={s.engagements} />
          <Stat icon={ShieldAlert} label="Risiko Signifikan" value={s.significant_risks} tone="bg-amber-100 text-amber-700" />
          <Stat icon={AlertTriangle} label="Risiko Kecurangan" value={s.fraud_risks} tone="bg-red-100 text-red-700" />
          <Stat icon={Ban} label="Rilis Diblokir" value={s.blocked_reports} tone="bg-red-100 text-red-700" />
        </div>

        <div className="bg-white border border-border rounded-sm">
          <div className="px-4 py-3 border-b border-border font-head font-semibold">Perikatan Aktif</div>
          <div className="overflow-x-auto">
            <table className="w-full audit-table">
              <thead>
                <tr>
                  <th>Perikatan</th><th>Klien</th><th>Periode</th><th>Fase</th>
                  <th className="text-right">Risiko Sig.</th><th className="text-right">Kecurangan</th>
                  <th className="w-40">Progres</th><th>EQR</th><th>Gerbang Rilis</th>
                </tr>
              </thead>
              <tbody>
                {data.engagements.map((e) => (
                  <tr key={e.id} className="cursor-pointer" onClick={() => navigate(`/engagements/${e.id}`)} data-testid={`eng-row-${e.id}`}>
                    <td className="font-medium">{e.name}</td>
                    <td>{e.client_name}</td>
                    <td className="text-muted-foreground">{e.period}</td>
                    <td>{e.phase}</td>
                    <td className="text-right tabular">{e.metrics.significant_risks}</td>
                    <td className="text-right tabular">{e.metrics.fraud_risks}</td>
                    <td>
                      <div className="flex items-center gap-2">
                        <Progress value={e.progress} className="h-1.5" />
                        <span className="text-xs tabular w-9">{e.progress}%</span>
                      </div>
                    </td>
                    <td>{e.eqr_required ? <span className="text-[11px] px-1.5 py-0.5 border rounded-sm bg-muted">Wajib</span> : <span className="text-muted-foreground text-xs">T/A</span>}</td>
                    <td>
                      <span className={`text-[11px] px-2 py-0.5 border rounded-sm font-medium ${GATE_STYLE[e.report_gate].cls}`}>
                        {GATE_STYLE[e.report_gate].label}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}
